@if (data?.length) {
  <isData [noDataIf]="false">
    <as-split direction="vertical" [gutterSize]="5">
      @if (chartData?.length) {
        <as-split-area [size]="40">
          <flexible-chart
            [data]="chartData"
            typeOfChart="bar"
            [isRange]="false"
          [options]="{
            axisX: true,
            axisY: true
          }"
          ></flexible-chart>
        </as-split-area>
      }
      <as-split-area [size]="chartData?.length ? 60 : 100">
        <isData [noDataIf]="!data?.length">
          @if (title) {
            <h1>{{ title }}</h1>
          }
          <cdk-virtual-scroll-viewport
            [itemSize]="18"
            style="height: calc(100% - 4rem); min-height: 200px; width: 100%"
            >
            <div
              *cdkVirtualFor="let item of data; let odd = odd"
              [ngStyle]="
                (odd && { 'background-color': 'rgba(0,0,0,0.07)' }) || {}
              "
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                cursor: pointer;
              "
              (click)="onRowClick(item)"
              >
              @for (col of columns; track col; let idx = $index) {
                <div
                  [style.flex]="idx === 3 ? 3 : 1"
                style="
                  margin-top: -1px;
                  margin-left: -1px;
                  width: 10%;
                  min-width: 200px;
                  padding: 0.5rem;
                  border: 1px solid #999;
                "
                  >
                  {{ col }}: {{ cellValue(item, col) }}
                </div>
              }
            </div>
          </cdk-virtual-scroll-viewport>
        </isData>
      </as-split-area>
    </as-split>
  </isData>
}
